import type { HTMLAttributes } from 'react'

declare const publishedLegalHtmlBrand: unique symbol
declare const previewLegalHtmlBrand: unique symbol

export type PublishedLegalHtml = string & {
  readonly [publishedLegalHtmlBrand]: 'published-legal-html'
}

export type PreviewLegalHtml = string & {
  readonly [previewLegalHtmlBrand]: 'preview-legal-html'
}

export type LegalHtmlValue = PublishedLegalHtml | PreviewLegalHtml

export function asPublishedLegalHtml(value: string): PublishedLegalHtml {
  return value as PublishedLegalHtml
}

export function asPreviewLegalHtml(value: string): PreviewLegalHtml {
  return value as PreviewLegalHtml
}

export function LegalHtml({
  html,
  ...props
}: HTMLAttributes<HTMLDivElement> & { html: LegalHtmlValue }) {
  return <div {...props} dangerouslySetInnerHTML={{ __html: html }} />
}
